import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import Skeleton from "@material-ui/lab/Skeleton";
import { getTokens } from "../../styles/tokens";

/* Skeleton neutro no formato da linha de conversa (TicketListItemCustom: 74px, avatar 46). */
const useStyles = makeStyles((theme) => {
	const t = getTokens(theme.palette.type, theme.palette.primary.main);
	return {
		item: {
			display: "flex",
			alignItems: "flex-start",
			gap: 10,
			minHeight: 74,
			boxSizing: "border-box",
			padding: "10px 14px 9px",
			borderBottom: `1px solid ${t.line}`,
			"& .MuiSkeleton-root": {
				backgroundColor: t.line,
			},
		},
		avatar: {
			flex: "none",
			marginTop: 1,
		},
		body: {
			flex: 1,
			minWidth: 0,
			display: "flex",
			flexDirection: "column",
			gap: 6,
		},
		row: {
			display: "flex",
			alignItems: "center",
			justifyContent: "space-between",
			gap: 8,
		},
		chips: {
			display: "flex",
			gap: 6,
		},
		rounded: {
			borderRadius: 6,
		},
		pill: {
			borderRadius: 9,
		},
	};
});

const rows = [
	{ name: 110, msg: "70%" },
	{ name: 140, msg: "55%" },
	{ name: 90, msg: "80%" },
];

const TicketsSkeleton = () => {
	const classes = useStyles();
	return (
		<>
			{rows.map((r, i) => (
				<div className={classes.item} key={i}>
					<Skeleton
						animation="wave"
						variant="circle"
						width={46}
						height={46}
						className={classes.avatar}
					/>
					<div className={classes.body}>
						<div className={classes.row}>
							<Skeleton animation="wave" variant="rect" height={12} width={r.name} className={classes.rounded} />
							<Skeleton animation="wave" variant="rect" height={10} width={34} className={classes.rounded} />
						</div>
						<Skeleton animation="wave" variant="rect" height={11} width={r.msg} className={classes.rounded} />
						<div className={classes.chips}>
							<Skeleton animation="wave" variant="rect" height={16} width={64} className={classes.pill} />
							<Skeleton animation="wave" variant="rect" height={16} width={48} className={classes.pill} />
						</div>
					</div>
				</div>
			))}
		</>
	);
};

export default TicketsSkeleton;
